import { defineStore } from "pinia";
import { ref } from "vue";

export type ComposeReplyRef = {
  folder: string;
  uid: number;
};

export type ComposeEmailOptions = {
  to?: string;
  cc?: string;
  bcc?: string;
  subject?: string;
  body?: string;
  reply?: ComposeReplyRef | null;
};

export const useComposeEmailStore = defineStore("composeEmail", () => {
  const open = ref(false);
  const to = ref("");
  const cc = ref("");
  const bcc = ref("");
  const subject = ref("");
  const body = ref("");
  const reply = ref<ComposeReplyRef | null>(null);

  const openCompose = (opts: ComposeEmailOptions = {}) => {
    to.value = (opts.to || "").trim();
    cc.value = (opts.cc || "").trim();
    bcc.value = (opts.bcc || "").trim();
    subject.value = opts.subject || "";
    body.value = opts.body || "";
    reply.value = opts.reply ?? null;
    open.value = true;
  };

  const closeCompose = () => {
    open.value = false;
  };

  return {
    open,
    to,
    cc,
    bcc,
    subject,
    body,
    reply,
    openCompose,
    closeCompose,
  };
});
